import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { withRouter } from "../../Utils/withRouter";
import { SetPlanId } from "../../Utils/localStorageService";

function PlanDetailPhone({
  plans_list,
  state,
  onPlanSelectHandler = () => null,
}) {
  const { selected_plan_id, selected_currency, selected_plan_duration } = state;
  const navigate = useNavigate();
  return (
    <div className="container">
      <div
        className="pricing pricing-bx pricing-palden pricing-palden-signup"
        style={{ marginBottom: "15px" }}
      >
        {plans_list instanceof Array &&
          plans_list.map((value, key) => {
            let planCost = {};
            if (selected_plan_duration === 1) {
              planCost = value?.monthly_cost;
            } else if (selected_plan_duration === 12) {
              planCost = value?.yearly_cost;
            } else {
              planCost = value?.twoYear_cost;
            }
            // if (value.plan_name.includes("Enterprise")) {
            //   return (
            //     <div
            //       className={`pricing-item justify-content-between ${
            //         value.planID === selected_plan_id
            //           ? "pricing__item--featured"
            //           : ""
            //       }`}
            //       onClick={() => onPlanSelectHandler(value)}
            //       key={key}
            //       style={{ position: "relative" }}
            //     >
            //       <div className="pricing-min-ht">
            //         <div className="pricing-deco">
            //           <div className="pricing-price">
            //             <h6 className="fw-700 start-up-head color-66  mb-2">
            //               {value.plan_name}
            //             </h6>
            //           </div>
            //           <p className="font--16 fw--400 color-66  mb-1">
            //             All our enterprise-ready features.
            //           </p>
            //           <p className="ideal-text">
            //             Ideal for Medium and Large teams
            //           </p>
            //           <h5 className="team-size ">
            //             Team Size: {`${value.max_user}`}
            //           </h5>
            //           <h6 className="every-text">
            //             Everything in Professional, PLUS
            //           </h6>
            //         </div>
            //         <ul className="pricing-feature-list">
            //           <li className="pricing-feature custom-pricing-feature">
            //             <h6 className="font-20 color-66 fw-700 mb-0">
            //               Custom pricing
            //             </h6>
            //             <p className="font--16 mt-2 color-66  mb-4">
            //               Trial Available
            //             </p>
            //           </li>
            //         </ul>
            //       </div>{" "}
            //       <div
            //         className={`d-flex justify-content-center ${
            //           value.planID === selected_plan_id ? "mt-53" : "mt-3"
            //         }`}
            //       >
            //         <button
            //           className="pricing-action m-0"
            //           onClick={() => navigate("demo")}
            //         >
            //           Get a Demo
            //         </button>
            //       </div>
            //       <p
            //         style={{ position: "absolute", bottom: "-50px", right: 0 }}
            //         className="text-align-end"
            //       >
            //         Taxes and Fees Apply*
            //       </p>
            //     </div>
            //   );
            // }
            return (
              <div
                key={value?.uniquecode}
                className={`pricing-item justify-content-between ${
                  value.planID === selected_plan_id
                    ? "pricing__item--featured"
                    : ""
                }`}
                onClick={() => onPlanSelectHandler(value)}
              >
                <div className="pricing-min-ht">
                  <div className="pricing-deco">
                    <div className="pricing-price">
                      {value.plan_name.includes("Professional") && (
                        <span className="recomended-text">Most Popular</span>
                      )}
                      <h6 className="fw-700 start-up-head color-66   mt-3 mb-0">
                        {value.plan_name}
                      </h6>
                    </div>
                    <div className="price-div-2">
                      <span className="pricing-currency color-3b">
                        {selected_currency}
                      </span>
                      {/* {selected_plan_duration === 1 && ( */}
                      <span className="color-b3 font-42 fw--400 cost-span">
                        {/* {selected_currency === "$" ? planCost?.$ : selected_currency === "R" ? planCost?.R : "00"} */}
                        {planCost?.amount ? planCost?.amount : "00"}
                      </span>
                      {/* // )} */}
                      {/* {selected_plan_duration === 12 && (
                        <span className="color-b3 font-42 fw--400 cost-span">
                          {selected_currency === "$" ? parseInt(planCost?.$ * 12) : selected_currency === "R" ? parseInt(planCost?.R * 12) : "00"}
                        </span>
                      )}
                      {selected_plan_duration === 24 && (
                        <span className="color-b3 font-42 fw--400 cost-span">
                          {selected_currency === "$" ? parseInt(planCost?.$ * 24) : selected_currency === "R" ? parseInt(planCost?.R * 24) : "00"}
                        </span>
                      )} */}
                    </div>
                    <h3 className="pricing-title">
                      Per user/month.( Billed annually)
                    </h3>
                    .
                    {/* <h5 className="team-size ">Team Size: {`${value.min_user}-${value.max_user}`}</h5> */}
                    <div className="team-size font--16">
                      {value?.planID === 9
                        ? "Users: Minimum 2"
                        : value.plan_name === "Enterprise"
                        ? "Users: Minimum 100+"
                        : "Users: Minimum 3"}
                    </div>
                    <p className="ideal-text">
                      {value.plan_name === "Start Up"
                        ? `Call Minutes: ${value.voice_minute} (Fair Usage Policy) `
                        : value.plan_name === "Scale Up"
                        ? `Call Minutes: ${value.voice_minute} (Fair Usage Policy) `
                        : value.plan_name === "Professional"
                        ? `Call Minutes: ${value.voice_minute} (Fair Usage Policy) `
                        : value.plan_name === "Enterprise"
                        ? `Call Minutes: ${value.voice_minute}+ (Unlimited by) `
                        : ""}
                    </p>
                    <h6 className="every-text">
                      {value.plan_name === "Start Up"
                        ? ""
                        : value.plan_name === "Scale Up"
                        ? "Everything in Start-Up Plan"
                        : value.plan_name === "Professional"
                        ? "Everything in Scale-Up Plan"
                        : value.plan_name === "Enterprise"
                        ? "Everything in Professional Plan"
                        : ""}
                    </h6>
                  </div>
                  <ul className="pricing-feature-list pricing-feature-list-new">
                    {[
                      value.plan_name === "Start Up" && [
                        `${value.free_did_number} Local/National Business Number`,
                        "Unlimited Inbound & Internal Calls",
                        " Voicemail & Voicemail-to-Email",
                        " Caller ID & Custom Hold Music",
                        " Call Forwarding & Call Transfers",
                        "Shared Call Inbox & Shared Contacts",
                        " Basic Call Analytics ",
                      ],
                      value.plan_name === "Scale Up" && [
                        " Unlimited Outbound Calls (Fair Usage Policy)",
                        " Interactive Voice Response (IVR) / Call Menus",
                        " Call Queues & Queue Callback Automation",
                        " Intelligent Call Routing & Ring Groups",
                        " Call Recording (Add-on available)",
                        "Business SMS Bundle",
                        " Team Assign & Comment on Calls",
                        " Call Ratings & Agent Performance Tracking",
                      ],
                      value.plan_name === "Professional" && [
                        "Business Landline or Toll-Free Number",
                        " Multiple Call Handling (Above 2 Channels)",
                        "After-Call Work: Call Notes & Call Disposition",
                        "Advanced Call Analytics & Reporting",
                        " Live Call Monitoring & Performance Tracking",
                        " Integration with SIP Desk Phones",
                        "Search Call Recordings",
                        "Pause & Resume Call Recording (Add-on available)",
                      ],
                      value.plan_name === "Enterprise" && [
                        " Dedicated Business Landline & Toll-Free Numbers",
                        "  Unlimited One-on-One & Group Calls",
                        " Unlimited AI Call Transcriptions & Summaries",
                        "AI-Powered Call Scoring & Call Insights",
                        "  Advanced Call Disposition & Tagging",
                        "  Enterprise-Level Call Analytics & Custom Reports",
                        " Role-Based Permissions & Admin Control",
                        "Two-Factor Authentication (2FA) & Single Sign-On (SSO)",
                        " Priority Customer Support & Premium Onboarding",
                      ],
                    ]
                      .filter(Boolean) // Remove falsy values (null/undefined)
                      .flat() // Flatten the nested arrays
                      .map((feature, index) => (
                        <li key={index}>
                          <i className="fas fa-check"></i>
                          {feature}
                        </li>
                      ))}
                  </ul>
                </div>
                <div
                  className={`d-flex justify-content-around ${
                    value.planID === selected_plan_id ? "mt-3" : ""
                  }`}
                >
                  {[9, 10].includes(value?.planID) && (
                    <Link
                      to="/signup"
                      className={`pricing-action`}
                      onClick={() => SetPlanId(value?.planID)}
                    >
                      14 day Trial
                    </Link>
                  )}
                  {[11, 12].includes(value?.planID) && (
                    <Link to="/demo" className={`pricing-action`}>
                      Get a Demo
                    </Link>
                  )}
                  {value?.planID !== 12 && (
                    <Link
                      to="/signup"
                      className={`pricing-action`}
                      onClick={() => SetPlanId(value?.planID)}
                    >
                      Signup
                    </Link>
                  )}
                </div>
              </div>
            );
          })}
      </div>
      <div
        style={{
          textAlign: "end",
          fontWeight: "700",
          marginRight: "130px",
          fontStyle: "bold",
          marginBottom: "-20px",
        }}
      >
        <p style={{ color: " #000" }}>*Taxes and Fees will apply</p>
      </div>
    </div>
  );
}

export default withRouter(PlanDetailPhone);
